export default {
  SET_TRANSACTIONS(state, data) {
    state.transactions = data.results
    state.transactionsCoutn = data.count
  },
  SET_TRANSACTION_INCOME_TYPE(state, data) {
    state.transaction_income_type = data
  },
  SET_TRANSACTION_CASHBOX(state, data) {
    state.transaction_cashbox = data
  },
  SET_TRANSACTION_INCOME_CHARTS(state, data) {
    state.transactionsIncomeCharts = data.results
    state.transactionsIncomeChartsCoutn = data.count
  },
}
